import { css, CSSObject } from "@emotion/react";
import {
  constants,
  typographyStyles,
  visuallyHiddenStyles,
} from "@newsela/angelou";

const colors = constants.colors;
const coreBlue = { 600: colors.ui.core[600], 500: colors.ui.core[500] };
const neutral400 = colors.ui.neutral[400];

css(visuallyHiddenStyles);

// --- Container ---
export const compareContrastContainer: CSSObject = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  backgroundColor: "#fff",
  padding: "16px",
  boxSizing: "border-box",
};

// --- Both section ---
export const bothSectionContainer = css({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
  margin: "0.1em 0",
});

export const bottomLineInputWrapper = css({
  border: "0",
  borderBottom: `5px solid ${coreBlue[600]}`,
  width: "17em",
  marginTop: "8px",
  paddingBottom: "4px",
});

export const bottomLineInput = css({
  border: `1px solid ${neutral400}`,
  borderRadius: "8px",
  padding: "0.3em 0",
  backgroundColor: "transparent",
  fontSize: "1.2em",
  fontWeight: "bold",
  textAlign: "center",
  width: "100%",
  color: "black",
  fontFamily: "inherit",
  "&::placeholder": {
    color: "#999",
  },
  "&:focus": {
    outline: "none",
    borderColor: coreBlue[600],
  },
});

export const inputsRow = css({
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-end",
  gap: "1.2em",
});

export const bothLabel = css({
  marginTop: "0.3em",
  color: "black",
  fontWeight: "bold",
  fontSize: "1.3em",
  whiteSpace: "nowrap",
  textAlign: "center",
});

// Venn container
export const vennDiagramContainer = css({
  position: "relative",
  width: "100%",
  maxWidth: "883px",
  height: "360px",
  marginTop: "1em",
});

// Left & Right ovals
const circle: CSSObject = {
  width: "550px",
  height: "360px",
  border: `4px solid ${coreBlue[600]}`,
  backgroundColor: "transparent",
  borderRadius: "200px / 200px",
  zIndex: 1,
  position: "absolute",
};

export const circleLeft: CSSObject = {
  ...circle,
  left: "0",
};

export const circleRight: CSSObject = {
  ...circle,
  right: "0",
};

export const vennDiagramTextAreaContainer: CSSObject = {
  display: "flex",
  justifyContent: "center",
  paddingTop: "70px",
  width: "100%",
  columnGap: "45px",
};

export const vennDiagramTextArea = (
  section: "left" | "right" | "center",
): CSSObject => {
  const sectionsSpecificStyles: CSSObject = {};

  if (section === "left" || section === "right") {
    sectionsSpecificStyles.width = "288px";
  } else if (section === "center") {
    sectionsSpecificStyles.width = "134px";
  }

  return {
    backgroundColor: "transparent",
    height: "219px",
    resize: "none",
    zIndex: 2,
    border: `1px solid ${neutral400}`,
    borderRadius: "8px",
    padding: "0.3em",
    color: "black",
    ...typographyStyles.textSObj,
    ...sectionsSpecificStyles,
    "&:focus": {
      outline: "none",
      borderColor: coreBlue[600],
    },
  };
};
